export default __webpack_public_path__ + "static/media/IMG_2068.e90f8dcd.jpeg";